import * as querystring from "../../util/querystring";
import React, { Component } from 'react';
import decode from 'jwt-decode';
import { Form, Icon, Input, Button, notification } from 'antd';
import CAFFENIO from '../../assets/images/CAFFENIO.svg';
import BARRA from '../../assets/images/BARRA_black.svg';
import CAFFENIO_2 from '../../assets/images/CAFFENIO.svg';
import Auth from '../../services/Auth'
import { DecryptToken } from "../../services/DecryptToken";
import { CAFFENIO_AUTH_PSW_RESTORE, CAFFENIO_AUTH_ID, CAFFENIO_AUTH_URL } from '../../constants';
import './Login.css'
import UsuariosRequest from '../../services/Usuarios';
import { checkToken } from "../../util/generics";
class Login extends Component {
    state = {
        loading: false,
        intentos: 0
    }

    /**
     * Función que carga los datos
     */
    componentDidMount() {
        // document.body.style.backgroundSize = "cover";
        // document.body.style.backgroundColor = "rgb(247, 247, 247)";
        // document.body.style.backgroundRepeat = "no-repeat";
        if (this.userIsLoggedIn()) {
            // Si ya hay un token guardado, se eliminan los query params
            this.clearParams();
        } else {
            // Si no, se parsean los queryparams para seguir con el flujo
            this.parseParams();
        }
    }

    /**
     * Función que se ejecuta cuando se salen del componente
     */
    componentWillUnmount() {
        document.body.style.backgroundImage = null;
        document.body.style.backgroundSize = null;
    }

    /**
     * Función que se ejecuta cuando hay un error
     * @param: type. valor de la notificación
     * @return: nada.
     */
    openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: 'Error',
            description: message,
        });
    };

    /**
     * Función que se ejecuta cuando da clic en aceptar
     * @param: e. valor del formulario 
     * @return: nada.
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true }, () => {
                    Auth.login(values.userName, values.password)
                        .then(response => {
                            let token = response.data.access_token;
                            let decodedToken = decode(token);
                            let today = new Date();
                            localStorage.setItem("expires_in", (today.getTime() / 1000) + response.data.expires_in)
                            console.log(" *** TOKEN *** ", decodedToken.role)
                            localStorage.setItem("token", token);
                            localStorage.setItem("tokenExpiration", decodedToken.exp);
                            localStorage.setItem("role", decodedToken.role);
                            //localStorage.setItem("role", ["Operador"]);
                            localStorage.setItem("id_user", decodedToken.uid);
                            localStorage.setItem("name", decodedToken.fullname);

                            UsuariosRequest.CrearUsuarioAuth()
                                .then(res => {
                                    localStorage.setItem('segmento', res.data.segmento)
                                    window.location.reload();
                                })
                                .catch(err => {
                                    localStorage.clear();
                                    this.setState({ loading: false })
                                    const message = err?.response?.data?.message ?? 'Por favor, ingrese un usuario y/o contraseña válidos.';
                                    this.openNotificationWithIcon("error", message)
                                });
                            /**/
                        }).catch(err => {
                            console.log("Error1: ", err)
                            this.openNotificationWithIcon("error", 'Por favor, ingrese un usuario y/o contraseña válidos.');
                            this.setState({ loading: false, intentos: (this.state.intentos + 1) })
                        })
                })
            }
        });
    }

    /**
     * Función que se ejecuta cuando se reintenta
     * iniciar sesión.
     */
    retry = () => {
        this.setState({ intentos: 0 })
    }

    //#region Funciones de utilidad para el redireccionamiento a CaffenioAuth
    /**
     * Función que hace el redireccionamiento a la vista de login de CaffenioAuth.
     */
    loginWithCaffenioAuth = () => {
        if (!this.state.loading) {
            const params = {
                applicationId: CAFFENIO_AUTH_ID,  // id de la aplicación
                applicationName: 'Sistema de Inventario',  // nombre de la aplicación
            }
            const payload = {
                payload: btoa(querystring.encode(params)),
            }
            window.location.replace(`${CAFFENIO_AUTH_URL}/?${querystring.encode(payload)}`);
        }
    }

    /**
     * Función que revisa los query params al entrar al front-end.
     * Si hay un query param entonces se asume que es de un token de CaffenioAuth y se obtiene el token de usuario
     */
    parseParams = () => {
        const parsedParams = this.decodeParams();
        const applicationToken = parsedParams.applicationToken;
        if (applicationToken && !this.state.loading) {
            // Si hay un application token es que el usuario viene de CaffenioAuth
            this.setState({ loading: true });
            DecryptToken.decryptToken(applicationToken).then(response => {
                if (response.data) {
                    this.saveToken(response.data.token, () => {
                        this.setState({ loading: false });
                        this.clearParams();
                        window.location.reload();
                    });
                }
            }).catch(err => {
                console.error(err);
            })
        } else if (!this.state.loading) {
            // En caso contrario, se redirecciona a Caffenio Auth
            this.loginWithCaffenioAuth();
        }
    }

    /**
     * Revisa si el usuario ha hecho login
     */
    userIsLoggedIn = () => {
        // let access = localStorage.getItem("token")
        // return access;
        return checkToken()
    }

    /**
     * Elimina los queryparams de la url
     */
    clearParams = () => {
        if (window.history.pushState) {
            window.history.pushState({}, null, window.location.origin + window.location.pathname)
        }
    }

    /**
     * Busca el parámetro "payload" en los queryparams y lo decodifica a un objeto.
     */
    decodeParams = () => {
        try {
            const parsedParams = querystring.parse(document.location.search.replace('?', ''));
            if (parsedParams.payload) {
                const decodedPayload = atob(parsedParams.payload);
                return querystring.parse(decodedPayload);
            }
        } catch {
            console.error("Error al parsear payload.");
        }
        return {};
    }

    /**
     * Guarda el token en local storage para validar al usuario
     */
    saveToken = (access_token, callback) => {
        if (access_token) {
            localStorage.setItem("token", access_token);
            // Cookies.set('token', access_token, {
            //     secure: true,
            //     sameSite: 'strict',
            //     // httpOnly: true,
            //     expires: 1
            // })
            let tokenObj = decode(access_token);
            let today = new Date();
            let expires_in = tokenObj.exp

            localStorage.setItem("expires_in", (today.getTime() / 1000) + expires_in);
            localStorage.setItem("tokenExpiration", tokenObj.exp);
            localStorage.setItem("role", tokenObj.role);
            localStorage.setItem("permissions", tokenObj.permissions);
            localStorage.setItem("id_user", tokenObj.uid);
            localStorage.setItem("name", tokenObj.fullname);

            UsuariosRequest.CrearUsuarioAuth()
            .then(res => {
                localStorage.setItem('segmento', res.data.segmento)
                // window.location.reload();
                callback()
            })
            .catch(err => {
                localStorage.clear();
                this.setState({ loading: false })
                const message = err?.response?.data?.message ?? 'Por favor, ingrese un usuario y/o contraseña válidos.';
                this.openNotificationWithIcon("error", message)
            });
        }
    }
    //#endregion

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div></div>
            // <div>
            //     <div >
            //         <header className="background-header" />
            //         <div style={{ border: "1px solid #d8d8d8", padding: "30px 30px 5px 30px", background: "white", borderRadius: "4px", width: 400, margin: "0vh auto", marginTop: "20vh" }}>
            //             <Logo black={true} />
            //             <p style={{ fontSize: "22px", color: "#000", textAlign: "center", fontWeight: 600 }}>Sistema de Inventario</p>
            //             <Form onSubmit={this.handleSubmit} className="login-form">
            //                 <Form.Item className="deleteRequiredStyle" label={<b>Usuario o correo electrónico</b>}>
            //                     {getFieldDecorator('userName', {
            //                         rules: [{ required: true, message: 'Por favor, ingrese su usuario o correo electrónico.' }],
            //                     })(
            //                         <Input size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Usuario / correo electrónico" />
            //                     )}
            //                 </Form.Item>
            //                 <Form.Item label={<b>Contraseña</b>}>
            //                     {getFieldDecorator('password', {
            //                         rules: [{ required: true, message: 'Por favor, ingrese su contraseña.' }],
            //                     })(
            //                         <Input size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Contraseña" />
            //                     )}
            //                 </Form.Item>
            //                 <Form.Item>
            //                     <Button
            //                         type="primary"
            //                         size="large"
            //                         htmlType="submit"
            //                         className="btnLogin"
            //                         loading={this.state.loading}
            //                         block
            //                     >
            //                         Iniciar sesión
            //                     </Button>
            //                 </Form.Item>
            //             </Form>
            //             <div className="link">
            //                 <a href={CAFFENIO_AUTH_PSW_RESTORE} target="_blank" rel="noopener noreferrer">¿Ha olvidado su contraseña?</a>
            //             </div>
            //         </div>
            //         <div style={{textAlign: "center"}}>
            //             <figure style={{ width: "170px", display: "inline-block", height: 'auto' }}>
            //                 <img className="logo" src={CAFFENIO} alt="CAFFENIO"/>
            //             </figure>
            //             <figure style={{ width: "170px", display: "inline-block", height: 'auto' }}>
            //                 <img className="logo" src={BARRA} alt="CAFFENIO" style={{marginBottom: "15px"}}/>
            //             </figure>
            //         </div>
            //     </div>
            // </div>
        );
    }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(Login);
const Logo = props => {
    return (
        <center>
            <figure style={{ width: "20vh" }}>
                {
                //<img className="logo" src={props.black ? CAFFENIO_2 : CAFFENIO} alt="CAFFENIO" />
                }
            </figure>
        </center>
    )
}

export default WrappedNormalLoginForm;